module.exports = __webpack_public_path__ + "static/img/4.dfcc973.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/zh/4.png
// module id = fWOF
// module chunks = 0